import React, { useState, useEffect } from 'react';
import { SelectPicker } from 'rsuite';
import { EditorState, Modifier } from 'draft-js';

type RenderCustomValueProps = {
  editorState?: any;
  onChange?: (value: string) => void;
};

const RenderCustomElement = ({
  editorState,
  onChange,
}: RenderCustomValueProps) => {
  const customValues = [
    'name',
    'email',
    'phone',
    'location_name',
    'survey_url',
  ];
  const customValuesLabels = customValues.map((value) => {
    return { label: value, value: value, role: '' };
  });

  const [value, setValue] = useState('');
  const addValue = (value) => {
    const renderValue = value !== null ? `{{${value}}}` : '';
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      renderValue,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, 'insert-fragment'));
  };
  return (
    <SelectPicker
      data={customValuesLabels}
      style={{
        minWidth: '160px',
        display: 'flex',
        margin: '3px',
      }}
      menuStyle={{ zIndex: '100000' }}
      searchable={false}
      placeholder='Custom Values'
      value={value}
      onChange={(value) => {
        addValue(value);
      }}
      placement='bottomEnd'
    />
  );
};

export default RenderCustomElement;
